import {PushNotificationsSpecialComponent} from '../../../js/custom-components/specials/push-notifications-special-component';
class SpecialsComponent extends React.PureComponent{	
	render(){
		
		return (	
				<PushNotificationsSpecialComponent />
		);
	}
}
export { SpecialsComponent };


// WEBPACK FOOTER //
// in/js/custom-components/specials/specials-component.js